import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { UserService } from 'services';
import { User } from 'models';

@Injectable({
    providedIn: 'root'
})
export class ClientResolver implements Resolve<User> {
    constructor(private userService: UserService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<User> {
        const clientId = route.paramMap.get('clientId');
        return clientId ? this.userService.getUserById(clientId) : of(null);
    }
}
